<template>
  <div>
    <a
      :href="hrefLink"
      :download="downloadLink"
    >
      <i class="bushel-icon bushel-2x bushel-download" />
    </a>
  </div>
</template>

<script>
import { getFileName } from "@/services/helpers";

export default {
  name: "DownloadableFile",
  props: {
    href: { type: String, required: true },
  },
  computed: {
    hrefLink() {
      return `/b-api/operations/farm/ingredients-doc/download/${this.href}`;
    },
    downloadLink() {
      return this.getFileName(this.href);
    },
  },
  methods: {
    getFileName,
  },
};
</script>

<style lang="scss" scoped>
div {
  a {
    cursor: pointer;
  }
}
</style>
